import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .rocky-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      width: 100%;
    }

    .image {
      grid-column: 2 / 8;
      grid-row: 2;
    }

    .image-description {
      grid-column: 2 / 8;
      grid-row: 3;
    }

    .image img {
      width: 100%;
    }

    .video {
      grid-column: 2 / 8;
      grid-row: 2;
      width: 100%;
      position: relative;
    }

    @media (min-width: 600px) {
      .rocky-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .image-description {
        grid-column: 2 / 14;
        grid-row: 3;
        margin-top: calc(14rem / var(--default-rem-px-count));
      }

      .video,
      .image {
        grid-column: 2 / 14;
        grid-row: 2;
      }

      .vimeo-wrapper {
        max-width: calc(900rem / var(--default-rem-px-count));
        margin: auto;
      }
    }
  `,
];
